module.exports = __webpack_public_path__ + "img/logo2.7382fff9.png";